/**
 * The id of a template named `name` on channel `commType` in a templates list
 * (GET /comms/templates), the newest when several match, or null.
 *
 * Used after a create that got no answer: the save may have gone through
 * (the dev API answered after the ingress gave up), and saying "not created"
 * invited a retry. Deleted rows never count; names compare exactly (after
 * trimming), channels ignoring case.
 *
 * @param {Array|object} templates the list, or a body carrying it as `data`/`templates`
 * @param {{name: string, commType: string}} wanted
 * @returns {string|null}
 */
export const findSavedTemplate = (templates, { name, commType }) => {
    const list = Array.isArray(templates)
        ? templates
        : templates?.data ?? templates?.templates ?? []
    if (!Array.isArray(list) || !name) return null
    const wantedName = name.trim()
    const wantedType = (commType ?? '').toLowerCase()
    const matches = list.filter(
        (t) =>
            t &&
            !t.deleted_status &&
            (t.template_name ?? '').trim() === wantedName &&
            (t.comm_type ?? '').toLowerCase() === wantedType
    )
    if (!matches.length) return null
    const newest = matches.reduce((a, b) =>
        Number(b.created_on ?? 0) > Number(a.created_on ?? 0) ? b : a
    )
    return newest.id ?? null
}
